module.exports = __webpack_public_path__ + "static/img/solution_img_intelligentsupervision_1.4355793.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/solution_img_intelligentsupervision_1.png
// module id = M0hI
// module chunks = 0